var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot",class:_vm.dotClasses})
}
var staticRenderFns = []

export { render, staticRenderFns }